<template>
  <div class="barrery-outer flex">
    <!-- <div class="barrery-inner text-center" v-for="(item,index) in userList" :key="index">
      <img src="@/assets/images/index/battery_icon.png"/>
      <div class="price text-df">32<span class="text-12">万</span></div>
      <div class="count text-12">乘用车电池数</div>
    </div> -->
    <BatteryWarrantyPie/>
  </div>
</template>
<script>
//饼图
import BatteryWarrantyPie from "@/components/echart/siteCharts/batteryWarrantyPie.vue";
export default {
  data () {
    return {
      options: {},
      userList:[{},{}]
    };
  },
  components: {
    BatteryWarrantyPie
  },
  props: {
    // userList: {
    //   type: Object,
    //   default: () => ({})
    // },
  },
  watch: {
    
  },
}
</script>
<style lang="scss" scoped>


// .taskIndicators{
//   width:1550px;
// }
</style>
